<template>
    <div
        class="shared-assignments"
        v-if="!preview">
        <div class="row">
            <div class="col-12 col-md-4 col-lg-3 shared-assignments-filters">
                <design-2021-portfolio-edit-shared-assignments-filters-component
                    v-model="filters"
                    :education-levels="educationLevelsIn"
                    :assignments-in="assignmentsIn"
                    :databank-type-in="groupIdIn !== null ? 'assignment' : 'organization'">
                </design-2021-portfolio-edit-shared-assignments-filters-component>
            </div>

            <div class="col-12 offset-md-2 col-md-6 offset-lg-0 col-lg-9">
                <b-alert
                    class="development-alert"
                    v-if="$authUser.isTeacher() || $authUser.isAdmin()"
                    variant="warning"
                    show>
                    {{
                        $t(
                            'portfolio.this_database_is_under_development_more_and_more_content_will_appear_for_you_in_the_near_future',
                        )
                    }}
                </b-alert>
                <design-2021-portfolio-edit-shared-assignment-card-component
                    :assignments-in="assignmentsIn"
                    :is-loading="isLoading"
                    :filters="filters"
                    :databank-type-in="groupIdIn !== null ? 'assignment' : 'organization'"
                    :portfolio-category-id-in="portfolioCategoryIdIn"
                    :group-id-in="groupIdIn"
                    :organization-id-in="organizationIdIn"
                    @add-assignment-to-assignments="addAssignment"
                    @preview-assignment="previewSelectedAssignment">
                </design-2021-portfolio-edit-shared-assignment-card-component>
            </div>
        </div>
    </div>

    <div
        class="preview"
        v-else>
        <design-2021-assignment-show-component
            :is-preview="true"
            :assignment-in="assignment">
        </design-2021-assignment-show-component>

        <div
            class="restore-assignments-overview"
            v-if="preview && organizationIdIn !== null">
            <b-button
                class="btn-restore-assignment-preview"
                variant="primary"
                @click="preview = !preview">
                {{ $t('portfolio.back_to_overview') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-shared-assignments-component',
    props: {
        educationLevelsIn: Array,
        assignmentsIn: Array,
        groupIdIn: {
            type: Number,
            default: null,
        },
        portfolioCategoryIdIn: {
            type: Number,
            default: null,
        },
        organizationIdIn: {
            type: Number,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        previewIn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filters: {},
            assignment: {},
            preview: false,
        };
    },

    methods: {
        getAssignments() {
            this.isLoading = true;
            // todo atm we are loading everything, should be changed in the future
            axios.get(this.routes.getabAssignmentsByCourse()).then(
                (response) => {
                    if (response.data.length) {
                        this.assignments = response.data;
                        this.sharedFilterAssignments = this.assignments;
                    }
                    this.isLoading = false;
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('portfolio.error_retrieving_shared_exercises'));
                },
            );
        },

        addAssignment(assignment) {
            this.$emit('add-assignment-to-list', assignment);
        },

        previewSelectedAssignment(abAssignmentId) {
            this.alert.loading();
            this.axios.get(`ab/assignment/${abAssignmentId}`).then(
                (response) => {
                    this.assignment = response.data;
                    this.preview = true;
                    this.alert.loaded();
                },

                (error) => {
                    this.preview = false;
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    watch: {
        preview: function (value) {
            this.$emit('update-preview-status', value);
        },

        previewIn: function (value) {
            this.preview = value;
        },
    },
};
</script>

<style scoped>
.preview >>> .container-with-shadow {
    box-shadow: none;
}

.restore-assignments-overview {
    margin-top: 30px;
    text-align: right;
}

.shared-assignments-filters {
    margin-bottom: 15px;
}

.development-alert {
    margin-bottom: 21px;
}

@media (min-width: 768px) {
    .shared-assignments-filters {
        margin-bottom: 0;
    }
}
</style>
